(function(){
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mob=innerWidth<750;
  if(!rm&&document.documentElement.dataset.jjSnow==='1'){
    var s=document.createElement('div');s.className='jj-snow';s.setAttribute('aria-hidden','true');
    var n=mob?10:24;
    for(var i=0;i<n;i++){var f=document.createElement('span');f.className='jj-flake';
      var sz=(mob?8:10)+Math.random()*(mob?6:10);
      f.style.cssText='left:'+(Math.random()*100)+'%;width:'+sz+'px;height:'+sz+'px;--dx:'+(Math.random()*60-30)+'px;animation-duration:'+(9+Math.random()*9)+'s;animation-delay:-'+(Math.random()*18)+'s';
      s.appendChild(f);}
    document.body.appendChild(s);
  }
  var h=document.querySelector('.header-wrapper');if(!h)return;
  if(getComputedStyle(h).position==='static')h.style.position='relative';
  var g=document.createElement('div');g.className='jj-garland';g.setAttribute('aria-hidden','true');
  var cnt=mob?9:18,cls=['r','p','g','k'],w='';
  g.innerHTML='<svg class="jj-wire" viewBox="0 0 '+cnt+' 1" preserveAspectRatio="none"><path d="M0 0'+Array.apply(null,Array(cnt)).map(function(_,i){return' Q'+(i+.5)+' 1.6 '+(i+1)+' 0'}).join('')+'" fill="none" stroke="#2F6B4F" stroke-width="1.5" vector-effect="non-scaling-stroke"/></svg>';
  for(var j=0;j<cnt;j++){var b=document.createElement('span');b.className='jj-bulb '+cls[j%4];b.style.left=((j+.5)/cnt*100)+'%';b.style.top='7px';b.style.animationDelay=(j%4*.6)+'s';g.appendChild(b);}
  g.addEventListener('pointerover',sw);g.addEventListener('click',sw);
  function sw(e){var t=e.target;if(!t.classList.contains('jj-bulb'))return;t.classList.remove('sway');void t.offsetWidth;t.classList.add('sway');}
  h.appendChild(g);
})();
